// ── API 基礎層：統一的 fetch 包裝器 ─────────────────────────────────────────────

export const API_BASE_URL = `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}/api`;

/**
 * 所有 API 請求的統一包裝器：
 * - credentials: 'include'  → 自動傳送 httpOnly cookie（S-3）
 * - AbortController timeout → 避免請求無限等待（P-2）
 * AI 生成類請求請傳入較長 timeoutMs（如 120000）
 */
export const apiFetch = async (url: string, options: RequestInit = {}, timeoutMs = 15000): Promise<Response> => {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);

  try {
    return await fetch(url, {
      ...options,
      credentials: 'include',
      headers: { ...options.headers },
      signal: controller.signal,
    });
  } finally {
    clearTimeout(timer);
  }
};

/** 對 AI 生成類請求：500 時自動重試一次，兩次皆失敗才拋出錯誤 */
export const apiFetchWithRetry = async (url: string, options: RequestInit = {}, timeoutMs = 120000): Promise<Response> => {
  const res = await apiFetch(url, options, timeoutMs);
  if (res.status === 500) {
    return apiFetch(url, options, timeoutMs);
  }
  return res;
};
